import { cn } from "../../../util/classNameConstructor";
import type { ButtonProps } from "../../core/button/Button";
import Button from "../../core/button/Button";

export const CopyrightIcon = ({
  copyright,
  captionId,
  className,
  ...props
}: {
  copyright: string;
  captionId?: string;
  className?: string;
} & ButtonProps) => {
  return (
    <>
      {captionId && (
        <span id={captionId} className="sr-only">
          {`© ${copyright}`}
        </span>
      )}
      {copyright && (
        <Button
          tooltipLabel={`© ${copyright}`}
          leadingIcon="info-circle"
          size="sm"
          variant="shapeless"
          leadingIconProps={{
            color: "white",
            className: "w-6 h-6",
          }}
          className="bg-black/10 no-touch:hover:bg-black/20 no-touch:active:bg-black/20"
          classNameWrapper={cn("absolute start-0 bottom-0 m-3 z-10", className)}
          tabIndex={-1}
          tooltipProps={{
            delay: 0,
            closeOnClick: false,
          }}
          {...props}
        />
      )}
    </>
  );
};
